import { render } from "./SettingsMenuLayout.vue?vue&type=template&id=22930e7e"
import script from "./SettingsMenuLayout.vue?vue&type=script&lang=js"
export * from "./SettingsMenuLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__